import {ButtonGroup, useEditableControls} from '@chakra-ui/react';
import {faClose} from '@fortawesome/pro-light-svg-icons/faClose';
import {faPencilAlt} from '@fortawesome/pro-light-svg-icons/faPencilAlt';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import noop from 'lodash/noop';
import {useCallback} from 'react';

import {Button, HStack, IconButton} from '../../index';

export type EditableControlsProps = {
  isHover?: boolean;
  onRemove?: () => void;
  disableRemove?: boolean;
};

export const EditableControls = (props: EditableControlsProps) => {
  const {isHover, onRemove = noop, disableRemove} = props ?? {};
  const {isEditing, getSubmitButtonProps, getCancelButtonProps, getEditButtonProps} = useEditableControls();

  const handleRemove = useCallback(() => {
    onRemove();
  }, [onRemove]);

  const formButtons = (
    <ButtonGroup alignSelf={`flex-start`} size={`sm`}>
      <Button variant={`secondary`} size={`sm`} {...getCancelButtonProps()}>
        Cancel
      </Button>
      <Button type={`submit`} variant={`primary`} size={`sm`} {...getSubmitButtonProps()}>
        Save
      </Button>
    </ButtonGroup>
  );

  return (
    <>
      {isEditing && formButtons}
      {!isEditing && (
        <HStack
          sx={{
            opacity: isHover ? 1 : 0,
          }}
          spacing={0}
        >
          <IconButton
            icon={<FontAwesomeIcon icon={faPencilAlt} />}
            aria-label={`Edit`}
            variant={`unstyled`}
            size={`xs`}
            {...getEditButtonProps()}
          />
          <IconButton
            icon={<FontAwesomeIcon icon={faClose} />}
            aria-label={`Remove`}
            variant={`unstyled`}
            size={`xs`}
            onClick={handleRemove}
            isDisabled={disableRemove}
          />
        </HStack>
      )}
    </>
  );
};
